import React from 'react';
import { CustomerSupportDemo } from '@/components/customer-support/CustomerSupportDemo';

const CustomerSupport: React.FC = () => {
  return <CustomerSupportDemo />;
};

export default CustomerSupport;